
import PerfectScrollbar from "perfect-scrollbar";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action, namespace } from "vuex-class";
import { TaskType } from "@/store/tasks/types";
import vSelect from "vue-select";

const Tasks = namespace("tasks");
const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class UrlInputLine extends Vue {
	public knownProtocols: string[] = [
		// @todo move to app-wide config
		"//",
		"/",
		"http://",
		"https://",
		"sftp://",
		"ftp://",
		"sop://",
		"udp://",
		"smb://"
	];
	public urlProtocol: string = "//";
	public urlPartial: string = "";
	public showErrorAnimation = false;
	public isValid = true;

	public get fullUrl(): string {
		return this.urlProtocol + this.urlPartial;
	}

	@Prop()
	public value!: string;
	// Watch full URL as it arrives from model and split into protocol and URL tail
	// @refactor modelValueChange(newValue) and urlPartialChange(newValue) into a single method
	@Watch("value", { immediate: true })
	public modelValueChange(newValue) {
		if (newValue) {
			// break incoming URL into protocol and tail
			if (newValue.startsWith("//")) {
				this.urlProtocol = "//";
				this.urlPartial = newValue.slice(2);
			} else if (newValue.startsWith("/")) {
				this.urlProtocol = "/";
				this.urlPartial = newValue.slice(1);
			} else {
				this.knownProtocols.slice(2).forEach(protocol => {
					if (newValue.startsWith(protocol)) {
						this.urlProtocol = protocol;
						this.urlPartial = newValue.slice(protocol.length);
					}
				});
			}
		}
		// console.log(`split URL from parent scope into: ${this.urlProtocol} and ${this.urlPartial}`);
	}

	// Watch changes to partial URL and if it starts with a known protocol:
	// separate the protocol and make appropriate selection in protocol dropdown,
	// change partial URL input to contain URL without the protocol
	@Watch("urlPartial", { immediate: true })
	public urlPartialChange(newValue) {
		if (newValue) {
			// break incoming URL into protocol and tail
			if (newValue.startsWith("//")) {
				this.urlProtocol = "//";
				this.urlPartial = newValue.slice(2);
			} else if (newValue.startsWith("/")) {
				this.urlProtocol = "/";
				this.urlPartial = newValue.slice(1);
			} else {
				this.knownProtocols.slice(2).forEach(protocol => {
					if (newValue.startsWith(protocol)) {
						this.urlProtocol = protocol;
						this.urlPartial = newValue.slice(protocol.length);
					}
				});
			}
		}
	}

	@Watch("urlProtocol")
	public protocolChanged(newValue, oldValue) {
		this.validate();
	}

	public validate() {
		// try { // @ref: https://developer.mozilla.org/en-US/docs/Web/API/URL
		//   new URL(this.newTask.title);
		//   isValid = true;
		// } catch(e) {
		//   isValid = false;
		// }

		this.isValid = true;
		var parser = document.createElement("a");
		parser.href = this.fullUrl;

		if (!parser.host.length) {
			this.isValid = false;
			this.showErrorAnimation = true;
			setTimeout(() => {
				this.showErrorAnimation = false;
			}, this.$config.ANIMATION_DURATION);
		}

		// add additional checks as necessary

		// Fire a validation event
		this.$emit("validate", this.isValid);

		if (this.isValid) {
			this.$emit("input", this.fullUrl);
		}
	}
}
